module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/_add-to-unscopables.js
// module id = 1403
// module chunks = 22